export default {
  pageTitle: 'Apply for TD',
  region: 'Region',
  applicationType: 'Application Type',
  applyProduct: 'Apply Product',
  check: 'Check',
  MRP: 'MRP',
  b: 'b',
  salePrice: 'Sale price',
  productRating: 'Product Rating：No', // 此处几项原文本就是写死的
  Sold: 'Sold：No',
  store: 'Store',
  shippingPlace: 'Warehouse and shipping place',
  batchSettings: 'Batch settings',
  placeholder1: 'Flash Price',
  dealPrice: 'deal price(b)',
  timeLimit: 'Time limit',
  time1: '1 day (24 hours)',
  time2: '2 days',
  time3: '3 days',
  time4: '5 days',
  time5: '7 days',
  time6: '15 days',
  time7: '30 days',
  success: '报名成功',
  faild: '以下SKU报名失败',
  registrationId: '报名ID',
  msg: 'Msg',
  // ----------------
  listingTableTitle1: 'SKU#',
  listingTableTitle2: 'title/spec',
  listingTableTitle3: 'listPrice',
  listingTableTitle4: 'salePrice',
  listingTableTitle5: 'stock',
  listingTableTitle6: 'deal Price',
  // ----------
  submitButtonVal1: 'Submit', // 参与逻辑判断
  placehOlderSession1: 'Please select', // 参与逻辑判断
  placehOlderSession2: 'Loading...',
  SUBM1: 'submit', // 参与逻辑判断
  SUBM2: 'update',
  // -------------------
  storeIdMap1: 'TopSelective',
  storeIdMap2: 'FlyingGoods',
  storeIdMap3: 'Cost-effective',
  storeIdMap4: 'FashionMall',
  storeIdMap5: 'Digitone',
  storeIdMap6: 'FlashSK',
  // ----------------
  warning1: 'SKU or Listing must be an integer.',
  warning2: 'SKU ID doesn\'t exist.',
  warning3: 'The SKU is offline.',
  warning4: 'The Listing is offline.',
  warning5: 'The information is incomplete.',
  warning6: 'Promise stock must be an integer.',
  warning7: '承诺库存不能超出商品现有库存.',
  warning8: 'Please enter greater than 0',
  warning9: 'Activity price must be an integer.',
  warning10: 'Activity price must be lower than sale price.',
  warning11: 'deal price can\'t be greater than Sale Price',
  warning12: 'deal price must be greater than 0',
  warning13: 'Please check listing data',
  error1: 'sku#未填写',
  error2: 'dealPrice未填写',
  error3: '至少要勾选一个SKU.',
  error4: 'deal price必须小于saleprice',
  error5: 'deal price必须大于0'
}
